import { AccountDto, CompanyRole } from '../../api/models/fraud.models';

export const DEFAULT_FREEZE_CORPORATE_ROLES: readonly CompanyRole[] = [
  CompanyRole.OWNER,
  CompanyRole.HEAD_OF_COMPLIANCE,
  CompanyRole.AML_OFFICER,
];

export function hasFreezeAccess(
  account: AccountDto | undefined,
  allowedCorporateRoles: readonly CompanyRole[] = DEFAULT_FREEZE_CORPORATE_ROLES,
): boolean {
  if (!account) {
    return false;
  }

  switch (account.accountType) {
    case 'PERSONAL':
      return true;
    case 'CORPORATE':
      return !!account.companyRole && allowedCorporateRoles.includes(account.companyRole);
    default:
      return false;
  }
}

export function hasExchangeRole(account: AccountDto | undefined): boolean {
  if (!account) {
    return false;
  }

  return !!(account && account.companyDto?.cluster);
}

export function isCompanyOwner(account: AccountDto | undefined): boolean {
  if (!account) {
    return false;
  }

  return account.accountType === 'CORPORATE' && account.companyRole === CompanyRole.OWNER;
}

export function canViewCompanyMembers(account: AccountDto | undefined): boolean {
  if (!account || account.accountType !== 'CORPORATE') {
    return false;
  }

  return account.companyRole === CompanyRole.OWNER || account.companyRole === CompanyRole.HEAD_OF_COMPLIANCE;
}
